export default __webpack_public_path__ + "static/media/email.f958187d.svg";